import { findUser, findUserByInternalNumber } from './findUser'
import { getImageUser } from './getImageUser'

export default {
  find: findUser,
  findByInternalNumber: findUserByInternalNumber,
  getImage: getImageUser
}
